import scrollNinja from './../ninja'

new scrollNinja(70)
